module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [(!_vm.hidePanel) ? _c('edit-pane', {
    ref: "ep",
    attrs: {
      "prefix": "Action: ",
      "title": _vm.form.summary,
      "is-edit": this.editMode
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit,
      "add": _vm.onSave
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "actionDetailsForm",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": _vm.mdreq,
      "lg": _vm.lgreq
    }
  }, [(this.isTowerCo() && !_vm.type) ? _c('div', [_c('select-action-type', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.form.actionType),
      callback: function($$v) {
        _vm.$set(_vm.form, "actionType", $$v)
      },
      expression: "form.actionType"
    }
  }), _vm._v("\n             \n        ")], 1) : _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Action Type"
    }
  }, [_c('b', [_vm._v(_vm._s(this.form.actionType))])])], 1)]), _vm._v(" "), (_vm.isRequest) ? _c('section', [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": _vm.mdreq,
      "lg": _vm.lgreq
    }
  }, [(_vm.isTowerCo()) ? _c('select-sharer', {
    attrs: {
      "label": "",
      "placeholder": _vm.isBackhaul ? 'Backhaul Customer' : 'Sharer',
      "limit": _vm.form.actionType != 'RTS' ? (_vm.limits && _vm.limits.length === 0 ? null : _vm.limits) : null,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.form.organisation_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "organisation_id", $$v)
      },
      expression: "form.organisation_id"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isBackhaul && (_vm.isTowerCo() || _vm.isTelco())) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": _vm.mdreq,
      "lg": _vm.lgreq
    }
  }, [_c('switch-input', {
    attrs: {
      "on-text": "Provider",
      "off-text": "Customer",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.isProvider),
      callback: function($$v) {
        _vm.isProvider = $$v
      },
      expression: "isProvider"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isBackhaul) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": _vm.mdreq,
      "lg": _vm.lgreq
    }
  }, [(_vm.isBackhaul && (_vm.isProvider || _vm.isBackhaulCo())) ? _c('select-backhaul-provider', {
    attrs: {
      "label": "Provider",
      "placeholder": "Select Backhaul Provider",
      "disabled": _vm.disabled || _vm.isBackhaulCo()
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.form.provider_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "provider_id", $$v)
      },
      expression: "form.provider_id"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.isBackhaul && _vm.isProvider) || _vm.isBackhaulCo()) ? _c('select-backhaul-type', {
    model: {
      value: (_vm.form.backhaulType),
      callback: function($$v) {
        _vm.$set(_vm.form, "backhaulType", $$v)
      },
      expression: "form.backhaulType"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isBackhaul && _vm.isProvider) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": _vm.mdreq,
      "lg": _vm.lgreq
    }
  }, [_c('check-box', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.isExcl),
      callback: function($$v) {
        _vm.isExcl = $$v
      },
      expression: "isExcl"
    }
  }, [_vm._v("\n                  Show only sites by provider\n              ")])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": _vm.mdreq,
      "lg": _vm.lgreq
    }
  }, [(_vm.isBackhaulCo()) ? _c('select-sharer', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.form.organisation_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "organisation_id", $$v)
      },
      expression: "form.organisation_id"
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showSiteSelect) ? _c('select-site', {
    ref: "selectSite",
    attrs: {
      "show-warning": true,
      "sharer": (_vm.isTelco() ? _vm.org().id : (_vm.isBackhaulCo() ? null : _vm.form.organisation_id)),
      "provider": (_vm.form.actionType === 'RTB') ? (_vm.isExcl ? _vm.form.provider_id : null) : null,
      "backhaul-search": (_vm.form.actionType === 'RTB'),
      "action-type": _vm.form.actionType.startsWith('RT') ? _vm.form.actionType : null,
      "exclude-sharer": (_vm.form.actionType === 'RTS'),
      "callback": _vm.successSite,
      "disabled": !(_vm.isProvider ? _vm.form.provider_id && _vm.form.organisation_id : _vm.isBackhaulCo() ? true : _vm.form.organisation_id)
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.form.site_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "site_id", $$v)
      },
      expression: "form.site_id"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "1em"
    }
  }, [(_vm.isTowerCo()) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Actual Date",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.actualDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "actualDate", $$v)
      },
      expression: "form.actualDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": _vm.isTelco() ? 12 : 8
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Target Date",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.targetDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "targetDate", $$v)
      },
      expression: "form.targetDate"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": _vm.isTelco() ? 12 : 8
    }
  }, [_c('select-priority', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.form.priority),
      callback: function($$v) {
        _vm.$set(_vm.form, "priority", $$v)
      },
      expression: "form.priority"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isTowerCo()) ? _c('text-input', {
    staticStyle: {
      "padding-top": "0.5em"
    },
    attrs: {
      "label": "Summary",
      "prop": "summary",
      "disabled": _vm.disabled,
      "placeholder": "Summary of action"
    },
    model: {
      value: (_vm.form.summary),
      callback: function($$v) {
        _vm.$set(_vm.form, "summary", $$v)
      },
      expression: "form.summary"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isTowerCo()) ? _c('el-form-item', {
    attrs: {
      "prop": "remarks",
      "label": "Remarks"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.remarks),
      callback: function($$v) {
        _vm.$set(_vm.form, "remarks", $$v)
      },
      expression: "form.remarks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.form && _vm.form.updated_at) ? _c('el-col', {
    attrs: {
      "align": "right",
      "span": 24
    }
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_vm._v("Last update: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.form.updated_at)))]), _vm._v(" (" + _vm._s(_vm.formatDateTime(_vm.form.updated_at)) + ")"), (_vm.form.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.form.updated_by))]) : _vm._e()])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b80de8be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/ActionDetails.vue
// module id = 1695
// module chunks = 0